import { useState } from "react"
import type { BlockComponentProps } from "./shared"

export function ImageBlock({ content, resolved }: BlockComponentProps) {
  // NOS-204: a dead src (403/hotlink-protected/failed rehost) must never reserve
  // blank vertical space. Collapse the whole figure on load error — same
  // component renders in the builder canvas and the public site, so both agree.
  const [failed, setFailed] = useState(false)
  const url = content?.url as string | undefined
  const alt = (content?.alt as string) ?? ""
  const caption = content?.caption as string | undefined
  if (!url || failed) return null
  const imageSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-6"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-6 @sm:px-6 @md:px-8"
  return (
    <section className={imageSectionClass} style={resolved.sectionStyle}>
      <figure className="max-w-2xl mx-auto">
        <img
          src={url}
          alt={alt}
          onError={() => setFailed(true)}
          className="w-full rounded-lg object-cover"
        />
        {caption && (
          <figcaption className="mt-2 text-sm text-muted-foreground text-center">
            {caption}
          </figcaption>
        )}
      </figure>
    </section>
  )
}
